import React from 'react';
import { Reveal } from './Reveal';
export function StorySection() {
  return <section className="w-full bg-cream py-16 sm:py-24" aria-labelledby="historia-title" data-id="element-318" data-mp="h0obgtc41sga">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-319" data-mp="gyv0j1ugsm2h">
        <Reveal data-id="element-320" data-mp="c2edkaz04dqz">
          <p className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-321" data-mp="c1uvmu9cppcy">
            La historia que cambia todo
          </p>
          <h2 id="historia-title" className="mt-4 max-w-3xl font-display text-3xl font-semibold leading-tight tracking-tight text-bark sm:text-[2.6rem]" data-id="element-322" data-mp="14q0gri4bhgdb">
            “Me llamó mi hermana desde el espejo”
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14" data-id="element-323" data-mp="voj09ymzzco3">
          <Reveal className="lg:sticky lg:top-10 lg:self-start" data-id="element-324" data-mp="qraiw09obcnw">
            <figure data-id="element-325" data-mp="qsu3g32d49vh">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/9b4799b1-5cd8-45f1-99d6-d5b39e14f9dc.jpg" alt="Autora del protocolo Código Cortisol, especialista en cronobiología nutricional" className="w-full rounded-2xl object-cover shadow-soft" loading="lazy" data-id="element-326" data-mp="3ggci8rdrztg0" />
              <figcaption className="mt-4 text-sm leading-relaxed text-ink/70" data-id="element-327" data-mp="1t6sntow2qhy4">
                Especialista en cronobiología nutricional. Escribí este protocolo después de
                aplicarlo primero en mi propio cuerpo.
              </figcaption>
            </figure>
          </Reveal>

          <div className="space-y-5 text-base leading-relaxed text-ink/85 sm:text-[1.05rem]" data-id="element-328" data-mp="1k7xfo79gyxs6">
            <Reveal data-id="element-329" data-mp="15fdgtitcrcgj">
              <p data-id="element-330" data-mp="1a7n6qyugwcit">
                Recuerdo exactamente la mañana en que entendí qué estaba pasando. Me desperté tras
                dormir 8 horas. Fui al baño. Me miré al espejo y no reconocí mi cara. Los ojos
                hundidos, las mejillas redondas, esa expresión de cansancio que ni el mejor contorno
                podía disimular.
              </p>
            </Reveal>
            <Reveal data-id="element-331" data-mp="rhfh9jjoxkl3">
              <p data-id="element-332" data-mp="rhymq0s5mgi8">
                Pasé las manos por mi abdomen y sentí una dureza inflamada, como si tuviera un globo
                lleno de agua debajo de la piel.
              </p>
            </Reveal>
            <Reveal data-id="element-333" data-mp="2ofmi46kannz3">
              <p data-id="element-334" data-mp="2of30ys2gx3m4">
                Había estado comiendo “perfecto”. Ensaladas, proteína magra, sin azúcares refinados.
                Iba al gimnasio 5 veces a la semana. Mi cardio era brutal. Y aun así, mis jeans no
                cerraban. Mi cara se veía como la de una mujer 10 años mayor.
              </p>
            </Reveal>
            <Reveal data-id="element-335" data-mp="3c34fchmbve9g">
              <p data-id="element-336" data-mp="38451u8mj696e">
                Fui al médico. <em data-id="element-337" data-mp="384wv3csnnuti">“Tus hormonas están bien. Tu tiroides está normal. ¿Estás
                comiendo demasiado?”</em> Me sentí humillada. Yo sabía qué estaba comiendo.
              </p>
            </Reveal>
            <Reveal data-id="element-338" data-mp="2y4wc5ryp7gpu">
              <p data-id="element-339" data-mp="2y5fqyzt1xozn">
                Fue entonces cuando una amiga me envió un artículo sobre el cortisol crónico. Leí
                una frase que cambió todo:
              </p>
            </Reveal>

            <Reveal data-id="element-340" data-mp="1mp7o0x9pkbng">
              <blockquote className="rounded-2xl border-l-4 border-clay bg-sand/70 px-6 py-6" data-id="element-341" data-mp="1cmlvfouz2yqw">
                <p className="font-display text-xl leading-snug text-bark sm:text-2xl" data-id="element-342" data-mp="1ckr9c77yt0l8">
                  “Cuando el cuerpo percibe amenaza constante, retiene sodio, apaga la digestión y
                  almacena grasa en el abdomen como mecanismo de protección. No importa cuántas
                  calorías quemes; tu sistema hormonal estará en contra tuya.”
                </p>
              </blockquote>
            </Reveal>

            <Reveal data-id="element-343" data-mp="20bn67ira2lzc">
              <p data-id="element-344" data-mp="20avc6cdbwwb6">
                Eso fue el quiebre. Mi cuerpo no estaba fallando:{' '}
                <strong className="font-semibold text-bark" data-id="element-345" data-mp="25caye7r8t8v5">estaba intentando protegerme</strong>. El
                cortisol, la hormona que debería activarse solo cuando hay peligro real, estaba
                activa 24/7 por el estrés, la falta de sueño y el sobreentrenamiento.
              </p>
            </Reveal>
            <Reveal data-id="element-346" data-mp="fwv0xpmolbl3">
              <p data-id="element-347" data-mp="fyflcmfa7e58">
                Pasé los siguientes 3 meses investigando cronobiología, neuroquímica y nutrición
                hormonal. Testé cada hipótesis en mi propio cuerpo. Y funcionó.
              </p>
            </Reveal>

            <Reveal data-id="element-348" data-mp="2fen1gls4t0g7">
              <ul className="grid gap-3 sm:grid-cols-3" data-id="element-349" data-mp="2fd25crq659g8">
                {[{
                day: 'En 7 días',
                text: 'la inflamación facial bajó notablemente.'
              }, {
                day: 'En 14 días',
                text: 'mis anillos volvieron a entrar.'
              }, {
                day: 'En 21 días',
                text: 'me veía en el espejo y veía a mí.'
              }].map(item => <li key={item.day} className="rounded-xl border border-bark/10 bg-cream px-4 py-4 shadow-soft" data-id="element-350" data-mp="1wg0yt2gyv1a6">
                    <p className="font-display text-lg text-clay" data-id="element-351" data-mp="1rn7u2elhzsy3">{item.day}</p>
                    <p className="mt-1 text-sm leading-relaxed text-ink/80" data-id="element-352" data-mp="13xnabthisrnr">{item.text}</p>
                  </li>)}
              </ul>
            </Reveal>

            <Reveal data-id="element-353" data-mp="3an8ihagbgz5g">
              <p data-id="element-354" data-mp="3amp23y6beitj">
                Escribí este protocolo porque nadie me lo explicó así cuando lo necesitaba. Y si te
                reconoces en esta historia, es porque tu cuerpo también está pidiendo ayuda.{' '}
                <strong className="font-semibold text-bark" data-id="element-355" data-mp="31nlecgw7df8p">
                  No está pidiendo más cardio. Está pidiendo seguridad.
                </strong>
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}